import React from 'react';
import moment from 'moment';
import _ from 'lodash';

import { m, isOverlapped } from '../../utils';
import Separator from '../shared/Separator';
import TimeCard from './TimeCard';

const SingleDay = ({
  cars = [],
  day = {},
  duration,
  selectedShifts,
  startTime,
  tier,
  toggleShiftList,
  vehicleAvailability,
}) => {
  const uid = `${m(day)
    .hour(startTime)
    .format('YYMMDDHH')}${m(day)
    .hour(startTime)
    .add(duration, 'hours')
    .format('YYMMDDHH')}`;

  const startDatetime = m(day).hour(startTime);

  const endDatetime = m(day)
    .hour(startTime)
    .add(duration, 'hours');

  const isAvailable =
    _.findIndex(
      vehicleAvailability,
      v =>
        startDatetime.isBetween(v.startTime, v.endTime, null, '[)') &&
        endDatetime.isBetween(v.startTime, v.endTime, null, '(]')
    ) !== -1;

  const isPast = m().isAfter(startDatetime.clone().subtract(40, 'minutes'));

  return (
    <div className={moment().isSame(day, 'day') ? 'week-day week-day_today' : 'week-day'}>
      <div className="day-position">
        <div className="date-number">{m(day).format('ddd')}</div>
        {m(day).format('D')}
      </div>

      <Separator className="half-width" />

      <TimeCard
        day={day}
        car={cars[0]}
        duration={duration}
        endDatetime={endDatetime}
        isAvailable={isAvailable && !isPast}
        isOverlapped={isOverlapped(selectedShifts, startDatetime, endDatetime)}
        selected={selectedShifts.map(s => s.uid).indexOf(uid) !== -1}
        startTime={startTime}
        startDatetime={startDatetime}
        tier={tier}
        toggleShiftList={toggleShiftList}
        uid={uid}
      />
    </div>
  );
};

export default SingleDay;



// WEBPACK FOOTER //
// ./src/components/WeeklyCalendar/SingleDay.js